module.exports = __webpack_public_path__ + "static/media/logo_bemvindo.148f8d7b.png";